import { global_var, lms_v2_api, video_upload_signed_url_endpoint, api_gateway_conn, sqlpad_api } from "./cs-lab-config";

function getIdeProjectDetails(ideProjectId) {
  return lms_v2_api.get("/ideProjects/" + ideProjectId);
}

function generateSqlpadDatabaseConnection() {
  return sqlpad_api.get("/api/app");
}

function getSqlpadDatabaseConnection() {
  return sqlpad_api.get("sqlpad/api/connections");
}

function createSqlDatabase(reqObj) {
  return sqlpad_api.post("sqlpad/api/create-database", reqObj);
}

function getSqlpadUserDatabases() {
  return sqlpad_api.get("sqlpad/api/userdatabases");
}
function saveFileInIde(ideProjectId, fileId, params) {
  return lms_v2_api.patch(
    "/ideProjects/updateFileOrFolder/" + ideProjectId + "/" + fileId,
    params
  );
}

function getFileContent(ideProjectId, fileId) {
  return lms_v2_api.get("/ideProjects/getFileContent/" + ideProjectId, {
    params: { fileOrFolderId: fileId },
  });
}

function getUrlToRunCode(ideProjectId, fileName, additionalParams) {
  return lms_v2_api.post("/ideProjects/getUrlToRunCode/", {
    ideProjectId,
    fileName,
    additionalParams
  });
}

function getProgrammingTip(programmingLanguage) {
  const params = {};
  if (programmingLanguage) {
    params["programmingLanguage"] = programmingLanguage;
  }
  return lms_v2_api.get("/ideProjects/getProgrammingTip/", { params });
}

function createFileOrFolder(ideProjectId, params) {
  return lms_v2_api.post(
    "/ideProjects/addFileOrFolder/" + ideProjectId,
    params
  );
}

function getPendingEvaluationCount(params) {
  return lms_v2_api.get("/ideProjects/PendingSubmittedEvaluationAssignments/", { params });
}



function deleteFileOrFolder(ideProjectId, fileId) {
  return lms_v2_api.delete(
    "/ideProjects/removeFileOrFolder/" + ideProjectId + "/" + fileId
  );
}

function createIdeProject(name, projectLanguage, additionalIdeDetails) {
  let ideProjectDetail = {
    fkIdeProjectType: "57c1cc5a9c5791610915abc4",
    fkIdeProjectTypeName: "CSLab",
    isFile: false,
    name,
    projectLanguage,
  }

  if (additionalIdeDetails) {
    if (additionalIdeDetails.isFile) {
      ideProjectDetail.isFile = true;
    }

    if (additionalIdeDetails.fileS3reference) {
      ideProjectDetail.fileS3reference = additionalIdeDetails.fileS3reference;
    }

    if (additionalIdeDetails.thumbnail) {
      ideProjectDetail.thumbnail = additionalIdeDetails.thumbnail;
    }

    if (additionalIdeDetails.uniqueFileId) {
      ideProjectDetail.uniqueFileId = additionalIdeDetails.uniqueFileId;
    }

    if (additionalIdeDetails.fkResourceId) {
      ideProjectDetail.fkResourceId = additionalIdeDetails.fkResourceId;
    }

    if (additionalIdeDetails.projectStatus) {
      ideProjectDetail.projectStatus = additionalIdeDetails.projectStatus;
    }

    if (additionalIdeDetails.fkActivityMapping) {
      ideProjectDetail.fkActivityMapping = additionalIdeDetails.fkActivityMapping;
    }

    if (additionalIdeDetails.totalMark) {
      ideProjectDetail.totalMark = additionalIdeDetails.totalMark;
    }

    if (additionalIdeDetails.fkUserActivityMappingId) {
      ideProjectDetail.fkUserActivityMappingId = additionalIdeDetails.fkUserActivityMappingId;
    }

    if (additionalIdeDetails.dueDate) {
      ideProjectDetail.dueDate = additionalIdeDetails.dueDate;
    }

  }
  return lms_v2_api.post("/ideProjects/", {
    ideProjectDetail: ideProjectDetail
  });
}


function renameIdeFileOrFolder(projectId, fileOrFolderId, newFileName, isFile) {
  return lms_v2_api.patch(
    "/ideProjects/updateFileOrFolder/renameFileOrFolder/" +
    projectId +
    "/" +
    fileOrFolderId,
    {
      newFileName,
      isFile,
    }
  );
}

function getIdeProjects(params) {
  for (let field in params) {
    if (!params[field]) {
      delete params[field];
    }
  }
  return lms_v2_api.get("/ideProjects/", { params });
}

function renameProject(ideProjectId, newFileName) {
  return lms_v2_api.patch("/ideProjects/" + ideProjectId, {
    newFileName,
  });
}

function deleteProject(ideProjectId) {
  return lms_v2_api.delete("/ideProjects/update/" + ideProjectId);
}

function addOrRemoveIdeProjectPortfolio(ideProjectId, showInPortFolio) {
  return lms_v2_api.patch("/ideProjects/update/" + ideProjectId, {
    updateObj: {
      showInPortFolio,
    },
  });
}

function updateIdeProject(ideProjectId, updateObj) {
  return lms_v2_api.patch("/ideProjects/update/" + ideProjectId, {
    updateObj: updateObj,
  });
}

function submitIdeProjectForEvaluation(ideProjectId) {
  return lms_v2_api.post("/ideProjects/ideProjectSubmission/", {
    ideProjectId,
  });
}

function cancelIdeProjectSubmission(ideProjectId) {
  return lms_v2_api.delete("/ideProjects/ideProjectSubmission/", {
    data: { ideProjectId },
  });
}

function saveIdeProjectEvaluation(
  ideProjectId,
  evaluationStatus,
  teacherRemark,
  scoredMark,
  evaluationRemarksObj,
) {
  const params = {
    ideProjectId,
    evaluationStatus,
  };
  if (teacherRemark) {
    params.teacherRemark = teacherRemark;
  }
  if (scoredMark) {
    params.scoredMark = scoredMark;
  }
  if (evaluationRemarksObj) {
    params.evaluationRemarks = evaluationRemarksObj;
  }
  return lms_v2_api.post("/ideProjects/evaluateProject/", params);
}

function loadClassRoomDetails(classObj) {
  return lms_v2_api.post("classDivision/loadClassRoomDetails/", classObj);
}

function getDivisionDetails(params) {
  return lms_v2_api.get("classDivision/getDivisionDetails/", { params });
}

function downloadProject(ideProjectId) {
  return lms_v2_api.get(`/ideProjects/download/${ideProjectId}`, {
    responseType: 'arraybuffer',
  });
}
function getResourceStudentLevels(ideProjectId) {
  return lms_v2_api.get("masters/resourceStudentLevel", {
  });
}
function fetchUsersByDynamicSearch(userObj) {
  return lms_v2_api.post("students/fetchUsersByDynamicSearch/", userObj);
}
function fetchActiveBatches(batchObj) {
  return lms_v2_api.post("course/loadCourseRelatedBatches/", batchObj);
}

function fetchActiveGroup(groupObj) {
  return lms_v2_api.post("activity/fetchGroups/", groupObj);
}

function saveMaterialToResource(resourceData) {
  return lms_v2_api.post("resources/", resourceData);
}

function assignLabQuestion(assignActivityObj) {
  return lms_v2_api.post("labQuestion/", assignActivityObj);
}

function fetchLabQuestion(params) {
  return lms_v2_api.get("/labQuestion/", {
    params: params,
  });
}

function fetchLabQuestionResource(params) {
  return lms_v2_api.get("/labQuestion/labQuestionResource", {
    params: params,
  });
}

function deleteResources(deleteObj) {
  return lms_v2_api.delete('labQuestion/', {
    data: deleteObj
  });
}

function getIdeAssignment(params) {
  for (let field in params) {
    if (!params[field]) {
      delete params[field];
    }
  }
  return lms_v2_api.get("/labQuestion/fetchStudentLabQuestion/", { params });
}

function getStudentSideResource(resourceId) {
  return lms_v2_api.get("resources/" + resourceId, resourceId);
}

function updateLabAssignmetDetails(resourceId, updateObj) {
  return lms_v2_api.patch("/labQuestion/update/" + resourceId, { updateObj });
}

function fetchResourceLabQuestion(resourceId) {
  return lms_v2_api.get("/labQuestion/fetchLabQuestionResource/" + resourceId);
}

function getAiCodeFeedback(ideProjectId) {
  return lms_v2_api.get("ideProjects/getAICodeFeedback/", { params: { ideProjectId } });
}

function loadAcademicYear(companyId, academicYearDetails) {
  return lms_v2_api.get("company/" + companyId + "/academicYear", { params: academicYearDetails });
}

function clearVncConf() {
  return lms_v2_api.delete("ideProjects/clearVncConf/");
}
function updateResources(updateObj) {
  return lms_v2_api.put('labQuestion/', updateObj);
}
function loadUsersUnderRole(userObj) {
  return lms_v2_api.post("students/LoadUsersUnderRole/", userObj);
}
function GetAllMenus() {
  return lms_v2_api.get("menu/GetAllMenus/", { params: { menuFor: 'CSLab' } });
}
function servLoadClassRoomMaster() {
  return lms_v2_api.get("classDivision/loadClassRoomMaster/");
}
function servGetRegisteredCompanies(companyObj) {
  return lms_v2_api.get('company/RegisteredCompanyView/', { params: companyObj })
}
function GetAssignedMenu(companyId, classId) {
  return lms_v2_api.post('menu/getCslabAssignedMenu/', { companyId, classId })
}
function saveMenuForTheCslab(data) {
  return lms_v2_api.post('menu/saveMenuForTheCslab/', data)
}
function loadMenuForCslab() {
  return lms_v2_api.get('menu/loadMenuForCslab/');
}
function CheckAncestorsExist(companyId) {
  return lms_v2_api.get('company/CheckAncestorsExist/?companyId=' + companyId)
}

function getLabAssignmentReport(resourceId, labQuestionMappingId, exportData) {
  if (!exportData.fkDivisionId) {
    delete exportData.fkDivisionId;
  }
  return lms_v2_api.post("/labQuestion/fetchLabQuestionReport/" + resourceId + '/' + labQuestionMappingId, exportData);
}

function exportToExcel(resourceId, labQuestionMappingId, exportData) {
  const url = '/labQuestion/exportLabQuestionReport';

  exportData.resourceId = resourceId;
  exportData.labQuestionMappingId = labQuestionMappingId

  let responseType;
  if (exportData.isDownload === 'excel') {
    responseType = 'blob';
  } else if (exportData.isDownload === 'pdf') {
    responseType = 'arraybuffer';
  } else {
    throw new Error('Invalid file type specified. Use "excel" or "pdf".');
  }

  return lms_v2_api.post(url,
    exportData, {
    responseType: responseType
  });
}

function updateLabAssignmetReport(resourceId, labQuestionMappingId, updateObj) {
  return lms_v2_api.patch("/labQuestion/updateReport/" + resourceId + "/" + labQuestionMappingId, { updateObj });
}

function installPackageInVnc(packageObj) {
  return lms_v2_api.post("/ideProjects/installVncPackage/", packageObj);
}

function sendExceptionNotification(reqObj) {
  return lms_v2_api.post("/common/sendExceptionNotification/", reqObj);
}

function loadStreams(reqObj) {
  return lms_v2_api.get("classDivision/getClassStreams/", { params: reqObj });
}

function loadClassStreamCategories(reqObj) {
  return lms_v2_api.get("classDivision/getClassStreamCategories/", { params: reqObj });
}

function bringsStreamsAndCategoriesInClassAndDivision(reqObj) {
  return lms_v2_api.post("classDivision/bringsStreamsAndCategoriesInClassAndDivision/", reqObj);
}

function servUploadFileToCloud(fileObj) {
  return new Promise((resolve, reject) => {
    const filepath = global_var.company_id + '/' + global_var.user_login_id + '/';

    // Step 1: Get the signed URL for uploading
    video_upload_signed_url_endpoint.get('fnGetVideoUploadSignedUrl', {
      params: {
        filename: fileObj.name,
        filepath: filepath,
        contentType: fileObj.type
      }
    }).then((response) => {
      response = response.data;

      // Step 2: Upload the file to the signed URL
      video_upload_signed_url_endpoint.put(response.uploadURL, fileObj, {
        headers: {
          'Content-Type': fileObj.type, // Set correct Content-Type
          'removeAuthCred': 'true',
        },
      }).then(() => {
        resolve({
          status: 'uploaded',
          fileKey: `${global_var.HOSTED_VIDEO_ENDPOINT}${response.fileKey}`
        });
      }).catch((error) => {
        console.error("Error uploading file:", error);
        reject(error);
      });
    }).catch((error) => {
      console.error("Error getting signed URL:", error);
      reject(error);
    });
  });
}

function servUploadFileToS3(fileObj, filepath, preventRandomNumber = false) {
  return new Promise((resolve, reject) => {

    const finalFilepath = global_var.FILE_UPLOAD_S3_FOLDER + '/' + filepath + '/';

    api_gateway_conn.get('file-upload/signed-url', {
      params: {
        filename: fileObj.name,
        filepath: finalFilepath,
        contentType: fileObj.type,
        preventRandomNumber: preventRandomNumber ? true : false
      }
    }).then((response) => {
      const data = response.data;

      const cleanedFileKey = data.fileKey.replace(/^uploaded(_test)?\//, '');

      const xhr = new XMLHttpRequest();
      xhr.open('PUT', data.uploadURL, true);
      xhr.setRequestHeader('Content-Type', fileObj.type);

      xhr.onload = function () {
        if (xhr.status === 200) {
          resolve({
            status: 'uploaded',
            fileKey: cleanedFileKey,
            uploadURL: data.uploadURL
          });
        } else {
          reject(xhr.responseText || `Upload failed with status ${xhr.status}`);
        }
      };

      xhr.onerror = function () {
        reject('Upload failed due to network or permission issue.');
      };

      xhr.send(fileObj);

    }).catch((err) => {
      reject(err);
    });
  });
}

function generateAiQuestion(reqObj) {
  return lms_v2_api.post("/labQuestion/generateAiQuestion", reqObj);
}

function regenerateAiQuestion(reqObj) {
  return lms_v2_api.post("/labQuestion/regenerateAiQuestion", reqObj);
}

function servManageAiFeatures(data) {
  return lms_v2_api.post('menu/manageAiFeatures/', data)
}

function servPublishProjectToPublic(ideProjectId) {
  return lms_v2_api.post('/ideProjects/public/' + ideProjectId);
}

function servUnPublishProjectFromPublic(ideProjectId) {
  return lms_v2_api.delete('/ideProjects/public/' + ideProjectId);
}

function getQueueResult(queueId) {
  return lms_v2_api.get(`/common/getQueueResult/${queueId}`);
}

export {
  saveFileInIde,
  getFileContent,
  getUrlToRunCode,
  getIdeProjectDetails,
  getProgrammingTip,
  getPendingEvaluationCount,
  fetchResourceLabQuestion,
  createFileOrFolder,
  deleteFileOrFolder,
  createIdeProject,
  renameIdeFileOrFolder,
  getIdeProjects,
  renameProject,
  deleteProject,
  addOrRemoveIdeProjectPortfolio,
  updateIdeProject,
  submitIdeProjectForEvaluation,
  cancelIdeProjectSubmission,
  saveIdeProjectEvaluation,
  loadClassRoomDetails,
  getDivisionDetails,
  downloadProject,
  fetchUsersByDynamicSearch,
  fetchActiveBatches,
  fetchActiveGroup,
  saveMaterialToResource,
  servUploadFileToS3,
  getResourceStudentLevels,
  assignLabQuestion,
  fetchLabQuestion,
  deleteResources,
  getIdeAssignment,
  getStudentSideResource,
  updateLabAssignmetDetails,
  getAiCodeFeedback,
  clearVncConf,
  fetchLabQuestionResource,
  updateResources,
  loadUsersUnderRole,
  GetAllMenus,
  servLoadClassRoomMaster,
  servGetRegisteredCompanies,
  GetAssignedMenu,
  saveMenuForTheCslab,
  loadMenuForCslab,
  CheckAncestorsExist,
  loadAcademicYear,
  getLabAssignmentReport,
  exportToExcel,
  updateLabAssignmetReport,
  installPackageInVnc,
  sendExceptionNotification,
  loadStreams,
  loadClassStreamCategories,
  bringsStreamsAndCategoriesInClassAndDivision,
  servUploadFileToCloud,
  generateAiQuestion,
  regenerateAiQuestion,
  servManageAiFeatures,
  servPublishProjectToPublic,
  servUnPublishProjectFromPublic,
  getQueueResult,
  generateSqlpadDatabaseConnection,
  getSqlpadDatabaseConnection,
  createSqlDatabase,
  getSqlpadUserDatabases
};
